import { useEffect } from 'react';

import { MESSAGE_TYPES } from '@/lib/constants/widget-events';
import { checkSession, sessionChangeKey } from '@/lib/guest-auth/browser-client';
import { isFromEmbeddingPage } from '@/lib/utils/dom';

// Safety net for a logout no signal reported (a host button we do not know, an expired session).
const POLL_MS = 30_000;

/** Re-checks the session when something outside this tab says it may have changed: the host
 *  page around the chat, or an in-chat sign-in or sign-out in a sibling tab; and on a timer regardless. */
export function useSessionSignals(tenant: string | null): void {
  useEffect(() => {
    if (!tenant) return;
    const sessionTenant = tenant;
    const timer = setInterval(() => void checkSession(sessionTenant), POLL_MS);
    function onMessage(event: MessageEvent) {
      if (!isFromEmbeddingPage(event)) return;
      if ((event.data as { type?: unknown } | null)?.type !== MESSAGE_TYPES.HOST_AUTH_CHANGED)
        return;
      void checkSession(sessionTenant);
    }
    function onStorage(event: StorageEvent) {
      if (event.key === sessionChangeKey(sessionTenant) && event.newValue)
        void checkSession(sessionTenant);
    }
    window.addEventListener('message', onMessage);
    window.addEventListener('storage', onStorage);
    return () => {
      clearInterval(timer);
      window.removeEventListener('message', onMessage);
      window.removeEventListener('storage', onStorage);
    };
  }, [tenant]);
}
